import { useState } from "react";

export type SmartSearchParams = {
  id: string | null;
  name: string;
  type: string;
};

function useSmartSearchParams() {
  return useState<SmartSearchParams>({
    id: null,
    name: "",
    type: "",
  });
}

export default useSmartSearchParams;
